import React from 'react';

const Footer = () => {
  return (
    <footer className="border-t border-graphite-700 bg-graphite-900 py-8 mt-12">
      <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center gap-4">
        <div className="font-mono text-graphite-600 text-sm">
          © {new Date().getFullYear()} KAIROKIT TECH. ALL SYSTEMS NOMINAL.
        </div>
        <p className="text-center" style={{ textTransform: 'none' }}><span>Made by </span><a href="https://diglab.ai/" target="_blank" rel="noopener noreferrer" style={{ textTransform: 'none' }}>DigLab.ai</a><span> and </span><a href="https://linglinkai.cn/" target="_blank" rel="noopener noreferrer" style={{ textTransform: 'none' }}>LingLinkAI.cn</a></p>
      </div>
    </footer>
  );
};

export default Footer;